import { STOREBRAND_PHONE_NUMBER } from 'Constants/phoneNumbers.constants';
import { Variable } from 'Types/text.types';
import { isDefined } from 'Utils/type.utils';

export const getPhoneNumberVariable = (
  customPhoneNumberVariable?: Variable,
): Variable => {
  const defaultPhoneNumberVariable = {
    linkText: STOREBRAND_PHONE_NUMBER.telString,
    href: STOREBRAND_PHONE_NUMBER.href,
  };
  return isDefined(customPhoneNumberVariable)
    ? customPhoneNumberVariable
    : defaultPhoneNumberVariable;
};
